import { DocumentsKeys } from '@/i18n/types/documents.types';

export const documents: Record<DocumentsKeys, string> = {
  documents: 'Documents',
  documentsDescription: 'Create, edit and manage text documents with rich formatting',
  newDocument: 'New Document',
  yourDocuments: 'Your Documents',
  createDocument: 'Create Document',
  editDocument: 'Edit Document',
  documentTitle: 'Document Title',
  documentContent: 'Document Content',
  saving: 'Saving',
  saveDocument: 'Save Document',
  exportToPdf: 'Export to PDF',
  openPdf: 'Open PDF',
  uploadPdf: 'Upload PDF',
  titleRequired: 'Title is required',
  documentCreated: 'Document Created',
  documentUpdated: 'Document Updated',
  documentDeleted: 'Document Deleted',
  documentCreatedSuccess: 'Your document has been created successfully',
  documentUpdatedSuccess: 'Your document has been updated successfully',
  documentDeletedSuccess: 'Your document has been deleted successfully',
  deleteDocument: 'Delete Document',
  deleteDocumentConfirmation: 'Are you sure you want to delete this document? This action cannot be undone.',
  selectDocumentOrCreateNew: 'Select a document from the list or create a new one',
  noDocumentsYet: 'No documents yet. Click the "New Document" button to create one.',
  loading: 'Loading...',
  error: 'Error',
  errorFetchingDocuments: 'Error loading documents. Please try again.',
  errorCreatingDocument: 'Error creating document. Please try again.',
  errorUpdatingDocument: 'Error updating document. Please try again.',
  errorDeletingDocument: 'Error deleting document. Please try again.',
  errorSavingDocument: 'Error saving document. Please try again.',
  mustBeLoggedIn: 'You must be logged in to perform this action.',
  textProcessor: 'Text Processor',
  pdfViewer: 'PDF Viewer',
  pdfViewerDescription: 'View and manage your PDF files',
  dropPdfFiles: 'Drop PDF files here or click to browse',
  pdfLoadError: 'Error loading PDF file',
  pageOf: 'Page {current} of {total}',
  previousPage: 'Previous Page',
  nextPage: 'Next Page',
  zoomIn: 'Zoom In',
  zoomOut: 'Zoom Out',
  resetZoom: 'Reset Zoom',
  downloadPdf: 'Download PDF',
  closePdf: 'Close PDF',
  noPdfSelected: 'No PDF selected. Upload a PDF file to view it.',
  wordCount: 'Words: {count}',
  characterCount: 'Characters: {count}',
  printDocument: 'Print Document',
  openDocument: 'Open Document',
};